import Ticket from "../../slices/help_desk/ticket/Ticket"
import ComplaintCategory from "../../slices/help_desk/complaint_category/ComplaintCategory"
import FindService from "../../slices/help_desk/find_service/FindService"
import Sos from "../../slices/help_desk/sos/Sos"
import TechnicalTicket from "../../slices/help_desk/technical_ticket/TechnicalTicket"

const helpDeskReducer = {
    ticket: Ticket,
    complaintCategory: ComplaintCategory,
    findService: FindService,
    sos: Sos,
    technicalTicket: TechnicalTicket,
}

export default helpDeskReducer;